import React from "react";
import PropTypes from "prop-types";
import "../style/main.min.css";
import Header from "./header";

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <main style={{ overflow: "hidden" }}>{children}</main>
      <footer className="mb-2">
        © {new Date().getFullYear()}, Built with
        {` `}
        <a href="https://www.gatsbyjs.org" target="_blank" rel="noreferrer">
          <span className="span hover">Gatsby</span>
        </a>
      </footer>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
